// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--3JrZ6","sixteenByNine":"styles-module--sixteenByNine--3G5Hr"};